// extracted by mini-css-extract-plugin
export var alignBaseline = "_18-9";
export var alignCenter = "_18-5";
export var alignFlexEnd = "_18-7";
export var alignFlexStart = "_18-6";
export var alignSelfBaseline = "_18-e";
export var alignSelfCenter = "_18-a";
export var alignSelfFlexEnd = "_18-c";
export var alignSelfFlexStart = "_18-b";
export var alignSelfStretch = "_18-d";
export var alignStretch = "_18-8";
export var column = "_18-2";
export var columnReverse = "_18-4";
export var flex = "_18-0";
export var justifyCenter = "_18-f";
export var justifyFlexEnd = "_18-h";
export var justifyFlexStart = "_18-g";
export var justifySpaceAround = "_18-j";
export var justifySpaceBetween = "_18-i";
export var justifySpaceEvenly = "_18-k";
export var row = "_18-1";
export var rowReverse = "_18-3";
export var wrapNowrap = "_18-m";
export var wrapWrap = "_18-l";
export var wrapWrapReverse = "_18-n";